
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const reviewApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listReviews: builder.query ({
      query: (params) => `v2/review/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["Review"]
    }),
    getReview: builder.query ({
      query: (review_id) => `v2/review/${review_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["Review"]
    }),
    getReviewNotes: builder.query ({
      query: (review_id) => `v2/note/?review=${review_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["Note"]
    }),
    updateReview: builder.mutation ({
      query: ({review_id, data}) => ({
        url: `v2/review/${review_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["Review"]
    }),
    deleteReview: builder.mutation ({
      query: (review_id) => ({
        url: `v2/review/${review_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["Review"]
    }),
    createReview: builder.mutation ({
      query: (data) => ({
        url: `v2/review/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["Review"]
    }),
  })
})


export const {
  useListReviewsQuery,
  useLazyListReviewsQuery,
  useGetReviewQuery,
  useLazyGetReviewQuery,
  useGetReviewNotesQuery,
  useUpdateReviewMutation,
  useDeleteReviewMutation,
  useCreateReviewMutation
} = reviewApi
